import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { bikeModelSelector, bikeColourSelector } from 'src/redux/bike/selectors';
import { disclaimerSelector } from 'src/redux/app/selectors';
import useChooseColour from 'src/hooks/useChooseColour';

import ItemWrapper from 'components/BikeSummaryItem/BikeSummaryItem';
import Label from 'components/_utility/Label';
import LuxuryTaxTotal from 'components/LuxuryTaxTotal/LuxuryTaxTotal';

import { Section, Header, HeaderTitle, ItemsSummary } from './SummaryColourCard.styled';

const SummaryColourCard = () => {
  const bikeColour = useSelector(bikeColourSelector);
  const bikeModel = useSelector(bikeModelSelector);
  const disclaimers = useSelector(disclaimerSelector);
  const chooseColour = useChooseColour();

  const [showAllColours, setShowAllColours] = useState(false);

  const bikeColours = bikeModel.colours;

  const basicPrice = bikeModel.price + (bikeColour.price - bikeModel.price);
  const isLuxuryTax = disclaimers.showLuxuryTaxDisclaimers;

  return (
    <Section>
      <Header>
        <HeaderTitle>
          <Label name="colourLabel" />
        </HeaderTitle>
      </Header>
      <ItemsSummary isLuxuryTax={isLuxuryTax}>
        {showAllColours ? (
          bikeColours.map(colour => (
            <ItemWrapper
              key={colour.id}
              swatchImage={colour.swatchImage}
              name={colour.name}
              price={colour.price}
              modelPrice={bikeModel.price}
              showAllColours={showAllColours}
              isColour
              selected={bikeColour.id === colour.id}
              hasCTA
              ctaAction={() => chooseColour(colour.id)}
              ctaLabel={bikeColour.id === colour.id ? 'selectedLabel' : 'selectLabel'}
            />
          ))
        ) : (
          <ItemWrapper
            swatchImage={bikeColour.swatchImage}
            name={bikeColour.name}
            price={bikeColour.price}
            modelPrice={bikeModel.price}
            selectedColourId={bikeColour.id}
            isColour
            hasCTA
            ctaAction={() => setShowAllColours(true)}
            ctaLabel={bikeColours.length > 1 ? 'changeColourLabel' : null}
          />
        )}
      </ItemsSummary>
      {isLuxuryTax ? (
        <LuxuryTaxTotal
          type="basicPrice"
          price={bikeColour === null ? bikeModel.price : basicPrice}
          label="basicPriceLabel"
        />
      ) : null}
    </Section>
  );
};

export default SummaryColourCard;
